import type { AdvancedSearchLocale } from "@/locales/fr/advanced-search";

const advancedSearchLocale: AdvancedSearchLocale = {
  advancedSearch: {
    title: "Advanced search",
    selectFields: "Select fields",
    addField: "Add a field",
  },
};

export default advancedSearchLocale;
